import { commonTranslationES } from "@common/translations/es";

export const spreadsheetDetailsES = {
  ...commonTranslationES,
  'Edit': 'Editar',
  'Load Fmt': 'Cargar formato',
  'Save Fmt': 'Guardar formato',
  'Export': 'Exportar',
  'Import': 'Importar',
  'Batch Letters': 'Cartas por lote',
  'Batch Invites': 'Invitaciones por lote',
  'Count': 'Contar',
  'Undo': 'Deshacer',
  'Redo': 'Rehacer',
  'Import more': 'Importar más',
  'numberOfMatchedColumns': 'Número de identificadores únicos en el archivo de importación que coinciden con las columnas de la hoja de cálculo',
  'Data Options': 'Opciones de datos',
  'Import blank cells over existing data': 'Importar celdas en blanco sobre datos existentes',
  'Import blank cells': 'Importar celdas en blanco',
  'Import into tables only': 'Importar solo en tablas',
  'Tab Delimited': 'Delimitado por tabulaciones',
  'Comma Delimited': 'Delimitado por comas',
  'Other (specify delimiter)': 'Otro (especificar delimitador)',
  'Data Import Definition': 'Definición de importación de datos',
  'Import Data': 'Importar datos',
  'Import Warnings': 'Advertencias de importación',
  'Importing individual data': 'Importando datos individuales',
  'out of': 'de',
  'imported successfully': 'importado exitosamente',
  'Failed to import data': 'Error al importar datos',
  'Load Pedigree Spreadsheet Format': 'Cargar formato de hoja de cálculo de pedigrí',
  'Load Individual Spreadsheet Format': 'Cargar formato de hoja de cálculo individual',
  'Individual Data Folders': 'Carpetas de datos individuales',
  'Failed to get folders': 'Error al obtener carpetas',
  'Failed to get fields': 'Error al obtener campos',
  'No': 'No',
  'Yes': 'Sí',
  'Are you sure you wish to remove all query clauses?': '¿Está seguro de que desea eliminar todas las cláusulas de consulta?',
  'Drag Fields From Warehouse And Drop Here': 'Arrastre campos desde el almacén y suéltelos aquí',
  'No data': 'Sin datos',
  'No folders': 'Sin carpetas',
  'Columns': 'Columnas',
  'Move Fields From Columns Panel Above': 'Mueva los campos desde el panel de columnas de arriba',
  'Or': 'O',
  'Save Pedigree Spreadsheet Format': 'Guardar formato de hoja de cálculo de pedigrí',
  'Save Individual Spreadsheet Format': 'Guardar formato de hoja de cálculo individual',
  'Text (Tab Delimited)': 'Texto (delimitado por tabulaciones)',
  'Text (Comma Delimited)': 'Texto (delimitado por comas)',
  'Text (Other)': 'Texto (otro)',
  'Excel (xls)': 'Excel (xls)',
  'Excel (xlsx)': 'Excel (xlsx)',
  'Include Column Headings': 'Incluir encabezados de columna',
  'Export Table Rows Only': 'Exportar solo filas de la tabla',
  'Export One Row Per Individual': 'Exportar una fila por individuo',
  'Retain newlines in formatted cells': 'Conservar saltos de línea en celdas formateadas',
  'Convert newlines to spaces': 'Convertir saltos de línea en espacios',
  'Export newlines without any formatting': 'Exportar saltos de línea sin formato',
  'Export Data': 'Exportar datos',
  'Settings': 'Configuraciones',
  'Delimiter': 'Delimitador',
  'Options': 'Opciones',
  'Newline Handling for Text Fields': 'Manejo de saltos de línea para campos de texto',
  'Exporting': 'Exportando',
  'Failed to export': 'Error al exportar',
  'Failed to get individual folders': 'Error al obtener carpetas individuales',
  'Failed to get pedigree folders': 'Error al obtener carpetas de pedigrí',
  'The Questionnaire invitation emails were successfully submitted': 'Los correos electrónicos de invitación al cuestionario se enviaron correctamente',
  'The Questionnaire invitation emails were successfully submitted for all individuals with a valid email address.': 'Los correos electrónicos de invitación al cuestionario se enviaron correctamente para todos los individuos con una dirección de correo electrónico válida.',
  'No folder selected. Please select a folder first.': 'No se ha seleccionado ninguna carpeta. Por favor, seleccione una carpeta primero.',
  'No individuals found in the current spreadsheet view': 'No se encontraron individuos en la vista actual de la hoja de cálculo',
  'Failed to load individuals from spreadsheet': 'Error al cargar individuos desde la hoja de cálculo',
  'Invitations sent to {emailsSent} individuals. Failed to send to {failedCount} individuals due to invalid email addresses: {failedNames}': 'Invitaciones enviadas a {emailsSent} individuos. Error al enviar a {failedCount} individuos debido a direcciones de correo electrónico inválidas: {failedNames}',
  'There was a problem with the email addresses for the following individuals': 'Hubo un problema con las direcciones de correo electrónico de los siguientes individuos:',
  'Failed to send invitations': 'Error al enviar invitaciones',
  'The spreadsheet could not be run because a comparison operator is missing a value for the following field(s) in the query. Please fix this error and re-run the spreadsheet': 'La hoja de cálculo no se pudo ejecutar porque a un operador de comparación le falta un valor para los siguientes campos en la consulta. Por favor, corrija este error y vuelva a ejecutar la hoja de cálculo',
  'spreadsheet.validation.missing.value': 'La hoja de cálculo no se pudo ejecutar porque a un operador de comparación le falta un valor para los siguientes campos en la consulta. Por favor, corrija este error y vuelva a ejecutar la hoja de cálculo',
  'Failed to update cell value': 'Error al actualizar el valor de la celda',
  'Failed to add row': 'Error al agregar fila',
  'Failed to delete rows': 'Error al eliminar filas',
  'The folder {folderName} already exists. Please enter a different name': 'La carpeta {folderName} ya existe. Por favor, ingrese un nombre diferente',
  'Please select fields to run the spreadsheet': 'Por favor, seleccione campos para ejecutar la hoja de cálculo',
  'Invalid format selected': 'Formato seleccionado inválido',
  'Failed to load format data': 'Error al cargar datos del formato',
  'Invalid format structure - no columns found': 'Estructura de formato inválida - no se encontraron columnas',
  'Failed to load format': 'Error al cargar formato',
  'Failed to save formats': 'Error al guardar formatos',
  'This name has already been used, would you like to overwrite the current format being used by this name?': 'Este nombre ya ha sido usado, ¿desea sobrescribir el formato actual que está siendo usado por este nombre?',
  'Failed to run spreadsheet': 'Error al ejecutar la hoja de cálculo',
  'Format loaded successfully': 'Formato cargado exitosamente',
  'Failed to load stored format data': 'Error al cargar datos de formato almacenados',
  'Pedigree Data Folders': 'Carpetas de datos de pedigrí',
  'This field is required': 'Este campo es obligatorio',
  'Missing required data for upload. Please ensure all required fields are available.': 'Faltan datos obligatorios para la carga. Asegúrese de que todos los campos obligatorios estén disponibles.',
  'Spreadsheet Count': 'Conteo de hoja de cálculo',
  'There are {displayCount} main row(s) in this spreadsheet': 'Hay %{displayCount} fila(s) principal(es) en esta hoja de cálculo',
  'Information Message': 'Mensaje informativo',
  'Number field accepts numeric values only, please re-try.': 'El campo numérico solo acepta valores numéricos, inténtelo de nuevo.',
  'Invalid number': 'Número no válido',
  'Upload Error': 'Error de carga',
  'Confirmation message': 'Mensaje de confirmación',
  'Upload Success': 'Carga exitosa',
  'Overwrite failed': 'Error al sobrescribir',
  'Overwrite': 'Sobrescribir',
  'File upload failed. Please try again.': 'La carga del archivo falló. Inténtelo de nuevo.',
  'File type not allowed: {fileName}': 'Tipo de archivo no permitido: {fileName}',
  'File "{fileName}" already exists. Overwrite?': 'El archivo "{fileName}" ya existe. ¿Desea sobrescribirlo?',
  'File "{fileName}" uploaded successfully.': 'El archivo "{fileName}" se cargó correctamente.',
  'Browse to {value}': 'Ir a {value}',
  'Open': 'Abrir',
  'Download': 'Descargar',
  'Click to view full image for {value}': 'Haga clic para ver la imagen completa de {value}',
  'Upload Image': 'Subir imagen',
  'Upload Document': 'Subir documento',
  'Yes (Y)': 'Sí (Y)',
  'No (N)': 'No (N)',
};